module.exports = __webpack_public_path__ + "img/胡芦巴.2dd158eb.jpg";